// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"669c51b6","187":"f1f24d97","331":"44d09b5f","386":"29e9432b","589":"b3260a5a","615":"b93dd436","679":"36368a51","815":"a3242269","977":"60d46e69"}[chunkId] + ".chunk.js";
};